import { cn } from '@workspace/utils';
import type { SelectHTMLAttributes } from 'react';
import React, { forwardRef } from 'react';
import type { SelectOption } from '../../types';
import { RenderedContent } from '../../utils';

export interface SelectNativeProps extends SelectHTMLAttributes<HTMLSelectElement> {
    children?: React.ReactNode;
    options: SelectOption[];
    placeholder?: RenderedContent;
    error?: boolean;
}

export const SelectNative = forwardRef<HTMLSelectElement, SelectNativeProps>(({ options, placeholder, defaultValue = '', value, error, disabled, ...props }, ref) => {
    return (
        <select
            className={cn(
                'bg-input-bg border border-input-border text-input-text outline -outline-offset-1 outline-1 h-10 pl-3 pr-4 rounded-md text-sm w-full',
                error ? 'outline-red-500 text-red-500' : 'outline-border',
                disabled && 'bg-gray-200 text-gray-500',
            )}
            value={value}
            defaultValue={value === undefined ? defaultValue : undefined}
            ref={ref}
            disabled={disabled}
            {...props}
        >
            <option
                disabled
                value=""
            >
                {placeholder}
            </option>
            {options.map((option, i) => (
                <option
                    key={i}
                    value={option.value ? option.value.toString() : ''}
                >
                    {option.label}
                </option>
            ))}
        </select>
    );
});

SelectNative.displayName = 'SelectNative';
